<div class="m-4">
    <h1 class="mb-4">Sale Summary</h1>

    <!-- Sale Section -->
    <div class="vehicle-section mb-4" *ngIf="sale">
        <h2>Sale</h2>
        <div class="card p-3 bg-light">
            <div class="row mb-2">
                <div class="col-md-4"><strong>Purchase Type:</strong> {{ sale.purchase_type | titlecase }}</div>
                <div class="col-md-4"><strong>Payment Type:</strong> {{ sale.payment_type | titlecase }}</div>
                <div *ngIf="sale.term" class="col-md-4"><strong>Term:</strong> {{ sale.term }} Months</div>
                <div *ngIf="sale.interest_rate" class="col-md-4"><strong>Interest Rate:</strong> {{ sale.interest_rate }}</div>
                <div *ngIf="sale.payment_frequency" class="col-md-4"><strong>Payment Frequency:</strong> {{ sale.payment_frequency | titlecase }}</div>
            </div>
        </div>
    </div>

    <!-- Vehicle Section -->
    <div class="vehicle-section mb-4" *ngIf="sale.make_id || sale.vin">
        <h2>Vehicle</h2>
        <div class="card p-3 bg-light">
            <div class="row mb-2">
                <div class="col-md-4"><strong>Make:</strong> {{ sale.make?.name }}</div>
                <div class="col-md-4"><strong>Model:</strong> {{ sale.model?.name }}</div>
                <div class="col-md-4"><strong>Year:</strong> {{ sale.model?.year }}</div>
                <div class="col-md-4"><strong>Trim:</strong> {{ sale.trim?.name }}</div>
                <div class="col-md-4"><strong>VIN:</strong> {{ sale.vin }}</div>
                <div class="col-md-4"><strong>Mileage:</strong> {{ sale.mileage }}</div>
                <div class="col-md-4"><strong>Condition:</strong> {{ sale.condition | titlecase }}</div>
                <div class="col-md-4"><strong>Price:</strong> {{ sale.vehicle_price }}</div>
            </div>
        </div>
    </div>

    <!-- Customers Section -->
    <div id="customers-section" class="mb-4">
        <h2>Customers</h2>
        <mat-accordion multi="true">
            <ng-container *ngFor="let customer of sale.customers">
                <mat-expansion-panel class="bg-white" [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mt-4 mb-4 fw-bold h4">
                            {{ customer.firstName }} {{ customer.lastName }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <app-customer-card [sale]="sale" [customer]="customer"></app-customer-card>
                </mat-expansion-panel>
            </ng-container>
        </mat-accordion>
    </div>

    <ng-container *ngIf="sale.orderSummary?.products as products">
        <div class="mb-5" *ngIf="products.length">
            <h2>Products</h2>
            <app-product-summary
                *ngFor="let product of products"
                [product]="product"
                [sale]="sale">
            </app-product-summary>
        </div>
    </ng-container>

    <div class="coupons-section mb-5">
        <div class="d-flex justify-between align-items-center mb-3">
            <h2 class="me-3 mb-0">Coupons</h2>

            <div class="d-flex w-50">
                <app-form-input
                    label="Enter your discount or promo code"
                    type="text"
                    [formControl]="couponFormControl"
                    (keydown.enter)="applyCoupon()"
                    class="flex-grow-1">
                </app-form-input>

                <button
                    class="button"
                    type="button"
                    (click)="applyCoupon()"
                    [disabled]="couponFormControl.invalid || (isApplyingCoupon$ | async) === true"
                >
                    <ng-container *ngIf="(isApplyingCoupon$ | async) === false; else loadingTpl">
                        Apply
                    </ng-container>
                    <ng-template #loadingTpl>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span class="visually-hidden">Applying...</span>
                    </ng-template>
                </button>
            </div>
        </div>

        <ng-container *ngIf="sale.orderSummary?.coupons?.length; else noCoupons">
            <app-coupon-summary
                *ngFor="let coupon of sale.orderSummary.coupons"
                [coupon]="coupon"
                [sale]="sale"
                [valueOverride]="coupon.applied_discount">
            </app-coupon-summary>
        </ng-container>

        <ng-template #noCoupons>
            <h4 class="text-center">No coupons are applied</h4>
        </ng-template>
    </div>

    <ng-container *ngIf="sale.orderSummary?.prizes?.length">
        <div class="prizes-section mb-5">
            <div class="d-flex justify-between align-items-center mb-3">
                <h2 class="me-3 mb-0">Prizes</h2>
            </div>

            <app-prize-summary
                *ngFor="let prize of sale.orderSummary.prizes"
                [prize]="prize">
            </app-prize-summary>
        </div>
    </ng-container>

    <div class="total-section" *ngIf="sale.orderSummary">
        <app-total-summary [summary]="sale.orderSummary"></app-total-summary>
    </div>
</div>
